import { PixelsJS } from '../../types/pixelsjs';

const { pixelsjs } = window;

const waitForPlaying = (player: PixelsJS) => new Promise((resolve) => player.one('playing', resolve));

async function persistentPlayer({ rootSelector, position }: Record<string, string>) {
  const root = document.getElementById(rootSelector);

  await waitForPlaying(this);

  const persistentAction = document.createElement('div');
  persistentAction.setAttribute('class', 'pixels-persistent-action-root');
  persistentAction.innerHTML = `<span class="close-persistent-player"><svg xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 384 512">
    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
</svg></span>`;
  root.appendChild(persistentAction);

  root.classList.add(position || 'top')

  const intersectionObserver = new IntersectionObserver((entries) => {
    const [{
      boundingClientRect: { top }, isIntersecting
    }] = entries;

    if (!isIntersecting && top < 0) {
      root.classList.add('pixel-persistence');
    } else {
      root.classList.remove('pixel-persistence');
    }
  });

  root.querySelectorAll('.close-persistent-player')
    .forEach((el) => {
      el.addEventListener('click', () => {
        root.classList.add('pixel-remove-persistence');
      });
    });

  intersectionObserver.observe(document.getElementById(rootSelector).parentNode as Element);
}

pixelsjs.registerPlugin('persistentPlayer', persistentPlayer);
